import styled, { css } from "styled-components";
import { pxToRem } from "styles/utils";

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${pxToRem(20)};
  background: ${({ theme }) => theme.colors.shadowStrong};
`;

export const ModalContent = styled.div`
  width: min(${pxToRem(420)}, calc(100vw - ${pxToRem(40)}));
  padding: ${pxToRem(22)};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0 ${pxToRem(18)} ${pxToRem(48)} rgba(31, 10, 53, 0.24);
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${pxToRem(16)};

  h2 {
    margin: 0;
    color: ${({ theme }) => theme.colors.ink};
    font-size: ${pxToRem(23.75)};
    font-weight: 600;
    letter-spacing: -0.01em;
  }
`;

export const SubText = styled.p`
  margin: ${pxToRem(5)} 0 ${pxToRem(18)};
  color: ${({ theme }) => theme.colors.inkSoft};
  font-size: ${pxToRem(16.25)};
`;

export const FieldGroup = styled.div`
  margin-bottom: ${pxToRem(14)};
`;

export const FieldLabel = styled.label`
  display: block;
  margin-bottom: ${pxToRem(6)};
  color: ${({ theme }) => theme.colors.inkSoft};
  font-size: ${pxToRem(16.25)};
`;

export const FieldWrap = styled.div`
  position: relative;
`;

export const Input = styled.input<{ $hasError?: boolean }>`
  width: 100%;
  height: ${pxToRem(42)};
  padding: 0 ${pxToRem(12)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.borders.field};
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.ink};
  font: inherit;
  font-size: ${pxToRem(18.75)};
  font-variant-numeric: tabular-nums;

  ${({ $hasError, theme }) => $hasError && css`
    border-color: ${theme.colors.danger};
  `}

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(-1)};
  }
`;

export const AmountInput = styled(Input)`
  padding-right: ${pxToRem(78)};
`;

export const AllAction = styled.div`
  position: absolute;
  top: 50%;
  right: ${pxToRem(6)};
  transform: translateY(-50%);

  > button {
    width: auto;
    min-width: 0;
    max-width: none;
    height: ${pxToRem(30)};
    padding: 0 ${pxToRem(10)};
  }
`;

export const FieldHint = styled.div<{ $error?: boolean }>`
  min-height: ${pxToRem(16)};
  margin-top: ${pxToRem(6)};
  color: ${({ $error, theme }) => ($error ? theme.colors.danger : theme.colors.inkMuted)};
  font-size: ${pxToRem(15)};
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${pxToRem(8)};
  margin-top: ${pxToRem(20)};

  > button {
    width: auto;
    min-width: ${pxToRem(110)};
    max-width: none;
  }
`;
